import { useState, useEffect } from "react"
import type { Locale } from "@/lib/i18n"
import { getTranslation } from "@/lib/i18n"
import { Header } from "@/components/header"
import { HeroSection } from "@/components/hero-section"
import { AboutSection } from "@/components/about-section"
import { FeaturesSection } from "@/components/features-section"
import { HowItWorksSection } from "@/components/how-it-works-section"
import { FAQSection } from "@/components/faq-section"
import { ContactSection } from "@/components/contact-section"
import { Footer } from "@/components/footer"

export default function App() {
    const [locale, setLocale] = useState<Locale>("uz")
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        // Get locale from localStorage or browser language
        const savedLocale = localStorage.getItem("locale") as Locale | null
        if (savedLocale) {
            setLocale(savedLocale)
        } else {
            const browserLang = navigator.language.split("-")[0]
            if (browserLang === "ru") setLocale("ru")
            else if (browserLang === "en") setLocale("en")
            else setLocale("uz")
        }
        setMounted(true)

        if (typeof window !== "undefined" && window.gtag) {
            window.gtag("event", "page_view", {
                page_path: window.location.pathname,
                page_title: document.title,
            })
        }
    }, [])

    const handleLocaleChange = (newLocale: Locale) => {
        setLocale(newLocale)
        localStorage.setItem("locale", newLocale)

        if (typeof window !== "undefined" && window.gtag) {
            window.gtag("event", "language_change", {
                language: newLocale,
            })
        }
    }

    const t = getTranslation(locale)

    if (!mounted) {
        return null
    }

    return (
        <div className="min-h-screen bg-background">
            <Header locale={locale} onLocaleChange={handleLocaleChange} translations={t} />
            <main>
                <HeroSection t={t} />
                <AboutSection t={t} />
                <FeaturesSection t={t} />
                <HowItWorksSection t={t} />
                <FAQSection t={t} />
                <ContactSection t={t} />
            </main>
            <Footer t={t} />
        </div>
    )
}
